import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AdminOrdersService } from 'src/app/features/orders/services/orders/admin-orders.service';
import { OrderState } from 'src/app/features/orders/state/order.state';
import { UserRoles } from 'src/app/models/enums/user-roles.enum';
import { UserService } from 'src/app/core/services/user/user.service';
@Component({
  selector: 'app-inspector-info',
  templateUrl: './inspector-info.component.html',
  styleUrls: ['./inspector-info.component.scss'],
})
export class InspectorInfoComponent {
  roles: string[];
  orders: any;
  userRoles = UserRoles;
  flag: boolean = false;
  paid = {
    is_paid: true,
  };
  @Select(OrderState.getOrderDetails) orderDetails$: Observable<any>;

  constructor(private order: AdminOrdersService, private userService: UserService) {}
  ngOnInit(): void {
    let groups = this.userService.userGroups;
    this.roles = groups.map((group) => group.identifier);
    this.orderDetails$.subscribe((data) => {
      this.orders = data;
    });
  }

  deliveredOrder(id, paid) {
    this.flag = true;
    this.order.changePaymentInspectorStatus(id, paid).subscribe(
      (data) => {
        this.orders.cost.inspector_payment_status = 'مدفوعة';
      },
      (error) => {
        try {
        } catch {}
      }
    );
  }
}
